<template>
  <v-container id="city-progress">
    <v-card>
      <v-row>
        <v-col align="center">
          <v-card-title>
            <v-select
              v-model="selected"
              :items="options"
              return-object
              label="Selecione uma opção"
            >
            </v-select>
          </v-card-title>
        </v-col>
        <v-col
          align="center"
          v-if="isFullAdmin || (groupsConfig && relatorioGlobal)"
        >
          <app-modal-report-global> </app-modal-report-global>
        </v-col>
      </v-row>
      <!-- pesquisa em soçlução -->
      <v-card-title
        v-if="
          selected.value === 'get-relatorios-por-solucao' ||
          selected.value === 'get-encontros-por-solucao' ||
          selected.value === 'get-situacao-visitas' ||
          selected.value === 'get-situacao-tarefas' ||
          selected.value === 'get-execucao' ||
          selected.value === 'get-execucao-por-tarefas-inicio-fim' ||
          selected.value === 'get-execucao-por-tarefas' ||
          selected.value === 'get-execucao-por-horas' ||
          selected.value === 'get-execucao-por-situacao-medalha' ||
          selected.value === 'get-execucao-por-situacao-pontos-medalha-por-tema'
        "
      >
        <v-row>
          <v-col cols="5">
            <v-combobox
              v-model="pesquisa.municipio"
              :items="filter.testecity"
              item-text="nome"
              item-value="municipioId"
              label="Municípios"
              clearable
              multiple
            ></v-combobox>
          </v-col>
          <v-col cols="3">
            <app-consultant-combobox
              :filter="pesquisa"
            ></app-consultant-combobox>
          </v-col>
          <v-col
            cols="2"
            v-if="
              selected.value != 'get-execucao' &&
              selected.value != 'get-execucao-por-tarefas'
            "
          >
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="auto"
              range
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Data Inicial"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="
                    menu = false;
                    filter.dataInicial = null;
                    $refs.menu.save(null);
                    reset();
                  "
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    selectDataInicial(date);
                    menu = false;
                    $refs.menu.save(date);
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="2"
            v-if="
              selected.value != 'get-execucao' &&
              selected.value != 'get-execucao-por-tarefas'
            "
          >
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="datefinal"
              transition="scale-transition"
              offset-y
              min-width="auto"
              range
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="datefinal"
                  label="Data Final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="datefinal" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="
                    menu2 = false;
                    filter.dataFinal = null;
                    $refs.menu2.save(null);
                  "
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="
                    selectDataFinal(datefinal);
                    menu = false;
                    $refs.menu2.save(datefinal);
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <!-- FIM PESQUISA POR MUNICIPIO  -->
          <!-- PESQUISA POR SOLUÇÃO  -->
          <v-col cols="6">
            <v-combobox
              v-model="pesquisa.solution"
              :items="filter.testesolution"
              item-value="solucaoId"
              item-text="nome"
              label="Solução"
              clearable
              multiple
            ></v-combobox>
          </v-col>
          <v-col cols="6">
            <app-group-solution-combobox
              :filter="filter"
            ></app-group-solution-combobox>
          </v-col>
        </v-row>
        <v-row> </v-row>
      </v-card-title>
      <v-card-title>
        <v-row>
          <v-col
            cols="6"
            v-if="
              selected.value === 'get-relatorios-por-solucao' ||
              selected.value === 'get-encontros-por-solucao' ||
              selected.value === 'get-situacao-visitas' ||
              selected.value === 'get-situacao-tarefas' ||
              selected.value === 'get-execucao' ||
              selected.value === 'get-execucao-por-tarefas' ||
              selected.value === 'get-execucao-por-horas' ||
              selected.value === 'get-execucao-por-situacao-medalha' ||
              selected.value ===
                'get-execucao-por-situacao-pontos-medalha-por-tema' ||
              selected.value === 'get-execucao-por-tarefas-inicio-fim'
            "
          >
            <AppGroupCombobox
              :filter="filter"
              :placeholderName="'Grupo de usuário'"
            ></AppGroupCombobox>
          </v-col>
          <v-col v-if="selected.value === 'get-municipios-sem-diagnostico'">
            <combobox-regional
              :regionais="regionais"
              :filter="filter"
            ></combobox-regional>
          </v-col>
          <v-col v-if="selected.value && selected.value != 'muncipio'">
            <AppStatusRelacionamento
              :filter="filter"
              :isMultiple="true"
            ></AppStatusRelacionamento>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-title v-if="selected.value == 'radar'">
        <v-row>
          <v-col cols="12">
            <rel-admin-radar></rel-admin-radar>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card>
        <v-row cols="12">
          <v-col md="12" sm="12" lg="8">
            <v-card-title v-if="selected.text == null"
              >Relatorio: Município</v-card-title
            >
            <v-card-title v-else>Relatorio: {{ selected.text }}</v-card-title>
          </v-col>
          <div v-if="selected.text != null">
            <v-row>
              <v-col md="12" sm="12" class="mr-8" lg="2">
                <v-btn elevation="2" v-on:click="gerarXlsx">Gerar XLS </v-btn>
              </v-col>
              <v-col md="12" sm="12" class="ml-16" lg="2">
                <v-btn elevation="2" v-on:click="Filtrar">Filtrar </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </v-card>
      <v-row v-if="modal">
        <v-col>
          <v-data-table
            :headers="headers"
            :items="listTable"
            :items-per-page="99"
            class="elevation-1"
          >
          </v-data-table>
        </v-col>
      </v-row>
      <v-row v-else>
        <Task-antiga
          :chartDataEncontros="chartDataEncontros"
          :chartDataAndamentosPerguntas="chartDataAndamentosPerguntas"
          :chartDataRelatoriosAdm="chartDataRelatoriosAdm"
          :chartDataRelatorios="chartDataRelatorios"
          :cities="cities"
          :loading="loading"
        ></Task-antiga>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import AppModalReportGlobal from "@/modules/report/components/ModalReportGlobal";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { mapActions, mapGetters } from "vuex";
import { options } from "../utils/optionsRotas";
import { headers } from "../utils/headers";
import TaskAntiga from "./taskantiga";
import FormData from "../utils/formatData";
import GerarPdf from "../utils/geraXls";
import { cityAPI } from "@/modules/city";
import { AppGroupSolutionCombobox } from "@/modules/group-solution";
import { AppConsultantCombobox } from "@/modules/user";
import { solutionAPI } from "@/modules/solution";
import AppGroupCombobox from "@/modules/user/components/group/Combobox";
import AppStatusRelacionamento from "@/modules/city/components/ComboboxStatusRelacionamento";
import RelAdminRadar from "./RelAdminRadar.vue";
import ComboboxRegional from "../Combobox/ComboboxRegional.vue";

// import pesquisaData from '../utils/pesquisaData'
// import modalPdf from './modalPdf.vue'
// import Jspdf from 'jspdf'
// import moment from 'moment'

export default {
  components: {
    TaskAntiga,
    AppGroupSolutionCombobox,
    // AppSolutionComboboxMultiple,
    AppConsultantCombobox,
    AppModalReportGlobal,
    // AppCityCombobox,
    // modalPdf
    AppGroupCombobox,
    AppStatusRelacionamento,
    RelAdminRadar,
    ComboboxRegional,
  },
  data() {
    return {
      regionais: [],
      relatorioGlobal:
        JSON.parse(localStorage.getItem("config")).relatorioGlobal || false,
      groupsConfig:
        JSON.parse(localStorage.getItem("groupsConfig")).relatorioGlobal ||
        false,
      modal: false,
      datefinal: "",
      date: "",
      menu: "",
      menu2: "",
      selected: {},
      options: options.filter(
        (item) => !item.estado || item.estado === this.$store.state.uf
      ),
      filtercity: [],
      filter: {
        grupoSolucaoId: 0,
        solucaoId: [],
        tarefaId: 0,
        evidenciaId: 0,
        solutions: [],
        tasks: [],
        evidences: [],
        municipio: {},
        usuario: {},
        municipios: [],
        dataInicial: 0,
        dataFinal: 0,
        testecity: [],
        testesolution: [],
        regionais: [],
        grupoId: null,
        statusId: [],
      },
      solutions: [],
      tasks: [],
      evidences: [],
      payload: {
        graficoEventos: [],
        graficoRelatorios: [],
        graficoRelatoriosAdministrativos: [],
        graficoPerguntas: [],
      },
      headers: headers,
      expanded: false,
      allTable: [],
      listTable1: [],
      listTable: [],
      // usando para props
      cities: [],
      chartDataEncontros: {},
      chartDataAndamentosPerguntas: {},
      chartDataRelatoriosAdm: {},
      chartDataRelatorios: {},
      municipios: [],
      pesquisa: {
        municipio: null,
        solution: [],
        usuario: [],
      },
      dialog: false,
      municipiosIds: [],
    };
  },
  watch: {
    selected(newValue) {
      if (newValue.value !== "muncipio") {
        this.getmunicipio(newValue);
        this.headers = this.selected.payload;
        this.modal = true;
      } else {
        this.modal = false;
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    getmunicipio(a) {
      if (this.filtercity.municipio && this.filtercity.municipio.length > 0) {
        this.municipiosIds = this.filtercity.municipio.map((e) => {
          return e.municipioId;
        });
      }

      let filtro = {
        Inicio: this.filter.dataInicial ? this.filter.dataInicial : null,
        Fim: this.filter.dataFinal ? this.filter.dataFinal : null,
        // Municipios: this.filter.municipios,
        // Solucoes: this.filter.solutions,
        Municipios: [],
        Solucoes: [],
        GrupoSolucao: this.filter.grupoSolucaoId,
        GrupoId: this.filter.grupoId || null,
        Status: this.filter.statusId.map((item) => item.statusId),
      };
      for (var i = 0; i < this.pesquisa.solution.length; i++) {
        filtro.Solucoes.push(this.pesquisa.solution[i].solucaoId);
      }
      if (this.pesquisa.municipio) {
        for (var ii = 0; ii < this.pesquisa.municipio.length; ii++) {
          filtro.Municipios.push(this.pesquisa.municipio[ii].municipioId);
        }
      }
      filtro.usuarioId = this.pesquisa.usuarioId;
      this.setLoading(true);
      administrativeDashboardAPI.getPesquisa(a.value, filtro).then((resp) => {
        if (a.value === "get-municipios-sem-diagnostico") {
          this.regionais = resp.data.map((item) => item.regional);
        }

        this.listTable = resp.data.map((item) => {
          item.possuiBronze = item.possuiBronze === true ? "Sim" : "Não";
          item.possuiOuro = item.possuiOuro === true ? "Sim" : "Não";
          item.possuiPrata = item.possuiPrata === true ? "Sim" : "Não";
          item.bronze = item.bronze === true ? "Sim" : "Não";
          item.ouro = item.ouro === true ? "Sim" : "Não";
          item.prata = item.prata === true ? "Sim" : "Não";

          return { ...item };
        });
        this.listTable1 = resp.data;
        if (a.value === "get-situacao-tarefas") {
          for (let item of this.listTable1) {
            item.dataEvento = FormData(item.dataEvento);
            // item.situacao = item.situacao
          }
        }
        if (
          a.value === "get-relatorios-por-solucao" ||
          a.value === "get-encontros-por-solucao"
        ) {
          for (let item of this.listTable1) {
            item.data = FormData(item.data);
          }
        }
        this.allTable = this.listTable;

        if (
          this.filter.regionais.length > 0 &&
          a.value === "get-municipios-sem-diagnostico"
        ) {
          this.listTable = this.listTable.filter((list) =>
            this.filter.regionais.some((item) => list.regional === item)
          );
        } else {
          this.listTable = this.allTable;
        }

        this.setLoading(false);
      });
      this.filter.municipios = [];
      this.filter.solutions = [];
      this.setLoading(false);
    },
    getDashboard() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getDashboard(this.filter)
        .then((resp) => {
          this.payload = resp.data;
          this.fillChartEncontros(this.payload.graficoEventos);
          this.fillChartRelatorios(this.payload.graficoRelatorios);
          this.fillChartRelatoriosAdm(
            this.payload.graficoRelatoriosAdministrativos
          );
          this.fillChartAndamentosPerguntas(this.payload.graficoPerguntas);
          this.getCities();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao buscar dados do dashboard");
        });
    },
    fillChartEncontros(payload) {
      this.chartDataEncontros = {
        labels: [payload[0].label, payload[1].label],
        datasets: [
          {
            backgroundColor: ["#FF5722", "#009688"],
            data: [payload[0].valor, payload[1].valor],
          },
        ],
      };
    },
    fillChartRelatorios(payload) {
      this.chartDataRelatorios = {
        labels: [
          payload[0].label,
          payload[1].label,
          payload[2].label,
          payload[3].label,
        ],
        datasets: [
          {
            backgroundColor: ["#FFC107", "#00796B", "#D32F2F", "#607D8B"],
            data: [
              payload[0].valor,
              payload[1].valor,
              payload[2].valor,
              payload[3].valor,
            ],
          },
        ],
      };
    },
    fillChartRelatoriosAdm(payload) {
      this.chartDataRelatoriosAdm = {
        labels: [
          payload[0].label,
          payload[1].label,
          payload[2].label,
          payload[3].label,
        ],
        datasets: [
          {
            backgroundColor: ["#FFC107", "#00796B", "#D32F2F", "#607D8B"],
            data: [
              payload[0].valor,
              payload[1].valor,
              payload[2].valor,
              payload[3].valor,
            ],
          },
        ],
      };
    },
    fillChartAndamentosPerguntas(payload) {
      this.chartDataAndamentosPerguntas = {
        labels: [
          payload[0].label,
          payload[1].label,
          payload[2].label,
          payload[3].label,
          payload[4].label,
        ],
        datasets: [
          {
            backgroundColor: [
              "#FFC107",
              "#00796B",
              "#D32F2F",
              "#607D8B",
              "#ccc",
            ],
            data: [
              payload[0].valor,
              payload[1].valor,
              payload[2].valor,
              payload[3].valor,
              payload[4].valor,
            ],
          },
        ],
      };
    },
    getCities() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getDashboardCities(this.filter)
        .then((resp) => {
          this.cities = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao buscar dados dos municípios");
        });
    },
    gerarXlsx() {
      if (this.selected.value === "muncipio") {
        GerarPdf(this.cities, this.selected.text);
      }
      GerarPdf(this.listTable, this.selected.text);
    },
    reloadSolutions() {
      this.filter.solucaoId = 0;
      if (this.filter.grupoSolucaoId) {
        this.filter.solutions = this.solutions.filter((i) => {
          return i.grupoSolucaoId === this.filter.grupoSolucaoId;
        });
        this.listTable = this.listTable1.filter((s) => {
          return s.grupoId === this.filter.grupoSolucaoId;
        });
      } else {
        this.filter.solutions = this.solutions;
        this.listTable = this.listTable1;
      }
    },
    selectSolutions() {
      if (this.filter.solucaoId.length > 0) {
        this.listTable = [];
        for (var i = 0; i < this.filter.solucaoId.length; i++) {
          this.listTable = this.listTable1.filter((s) => {
            return s.solucaoId === this.filter.solucaoId[i];
          });
        }
      } else {
        this.reloadSolutions();
      }
    },
    selectCities() {
      if (this.filtercity.municipio.length > 0) {
        this.listTable = [];
        for (var i = 0; i < this.filtercity.municipio.length; i++) {
          this.listTable = this.listTable1.filter((s) => {
            return s.municipioId === this.filtercity.municipio[i].municipioId;
          });
        }
      } else {
        this.reloadSolutions();
      }
    },
    loadSolutions() {
      this.setLoading(true);
      solutionAPI
        .list({})
        .then((resp) => {
          this.solutions = resp.data;
          this.filter.solutions = resp.data;
          this.reloadSolutions();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao listar soluções");
        });
      this.setLoading(false);
    },
    reset() {
      this.reloadSolutions();
    },
    SelectMunicipio(value) {
      this.filter.municipios = value;
    },
    selectSolution(value) {
      this.filter.solutions = value;
    },
    selectDataInicial(data) {
      this.filter.dataInicial = data;
    },
    selectDataFinal(data) {
      this.filter.dataFinal = data;
    },
    getmunicipioapi() {
      cityAPI.list().then((res) => {
        this.filter.testecity = res.data;
      });
    },
    getsolucionApi() {
      solutionAPI.list({}).then((res) => {
        this.filter.testesolution = res.data;
      });
    },
    Filtrar() {
      this.getmunicipio(this.selected);
    },
    CarregarCombos() {
      this.getmunicipioapi();
      this.getsolucionApi();
    },
    pesquisalista() {
      let lista1 = this.listTable1.filter((item) => {
        let filtro;
        if (
          this.pesquisa.solution.length === 0 &&
          this.pesquisa.municipio == null
        ) {
          filtro = item;
        }
        if (item.municipio === this.pesquisa.municipio) {
          filtro = item;
        }
        if (this.pesquisa.solution.length >= 1) {
          for (let solution of this.pesquisa.solution) {
            if (item.solucao === solution) {
              filtro = solution;
            }
          }
        }
        return filtro;
      });
      this.listTable = lista1;
    },
    /*
    gerarPDF (table) {
      // let logo = 'src/assets/logo.png'
      const columns = []
      let data = moment().format('DD/MM/YYYY')
      for (let col of this.headers) {
        columns.push({ title: col.text, dataKey: col.value })
      }
      const pdf = new Jspdf()
      pdf.setFontSize(10)
      pdf.text(this.selected.text, 15, 20)
      pdf.text('Data: ' + data, 15, 25)
      pdf.autoTable({
        columns,
        body: table,
        margin: { top: 30 }
      })
      pdf.save(this.selected.text + '.pdf')
    } */
  },
  mounted() {
    this.getDashboard();
    this.loadSolutions();
    this.getmunicipioapi();
    this.getsolucionApi();
    this.options = options.filter(
      (item) => !item.isFullAdmin || this.isFullAdmin
    );
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isAnalista",
      "isSPFesp",
      "isFullAdmin",
      "isSPFespEspecial",
      "isSPCoordenador",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
